module.exports = __webpack_public_path__ + "static/img/moshi_light.ac15e416.png";